import styled, { keyframes } from "styled-components";
import { GradientSpinner } from "./Spinner";

export const LoadingOverlay = () => {
  return (
    <SpinnerContainer>
      <GradientSpinner />
    </SpinnerContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const SpinnerContainer = styled.div`
  animation: ${fadeIn} 0.5s ease forwards;
  z-index: var(--depth-before-navigation);
  background: var(--loading-overlay-background);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  pointer-events: none;
`;
